<template>
	<article class="transactions__item transaction card">
		<i class="transaction__icon transaction__icon--green">
			<Icon name="plus" />
		</i>
		<div class="transaction__body">
			<dl class="transaction__row">
				<dd class="transaction__title">Replenishment</dd>
				<dt class="transaction__value transaction__value--big" data-currency="USDT">+{{ props.deposit.amount.toFixed(2) }}</dt>
			</dl>
			<dl class="transaction__row">
				<dd class="transaction__subtitle">Commission</dd>
				<dt class="transaction__value" data-currency="USDT">-{{ props.deposit.commission.toFixed(2) }}</dt>
			</dl>
			<dl class="transaction__row">
				<dd class="transaction__subtitle">{{ shorty(props.deposit.wallet, 8) }}</dd>
				<dt class="transaction__date">{{ date }}</dt>
			</dl>
		</div>
	</article>
</template>
<script lang="ts" setup>
import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";
import {computed} from "vue";
import WithdrawalEntity from "@/entities/WithdrawalEntity";
import DepositEntity from "@/entities/DepositEntity";
import {shorty} from "@/modules/helpers";

interface Props{
	deposit : DepositEntity
}

let props = defineProps<Props>();

let date = computed<string>(() => {
	return moment(props.deposit.created_at).format('DD.MM.YYYY HH:mm');
})

</script>